import React from "react";
import { Drawer } from "antd";
import "./DrawerStyle.scss";

const DynamicDrawer = ({
	open,
	close,
	width,
	title,
	height,
	placement,
	children,
	style,
	extra,
	customClass = "dynamicDrawer",
	closable = false,
	maskClosable = true,
	mask = true,
	zIndex,
	getContainer,
	overflow = "scroll",
	...rest
}) => {
	return (
		<Drawer
			open={open}
			closable={closable}
			onCancel={close}
			onClose={close}
			footer={null}
			width={width}
			title={title}
			bodyStyle={{
				height,
				overflow,
				...style,
			}}
			className={customClass}
			extra={extra}
			maskClosable={maskClosable}
			mask={mask}
			zIndex={zIndex}
			getContainer={getContainer}
			placement={placement}
			{...rest}
		>
			{children}
		</Drawer>
	);
};

export default DynamicDrawer;
